import { render, staticRenderFns } from "./LectureMainPage.vue?vue&type=template&id=473e0c78"
import script from "./LectureMainPage.vue?vue&type=script&lang=js"
export * from "./LectureMainPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports